export const enum SelfExclusionType {
	Standard = "standard",
	Oasis = "oasis",
	ExternalLink = "external-link",
	Indefinite = "indefinite",
}

export const enum LoginStatus {
	LoggedIn = "LoggedIn",
}

export const SELF_EXCLUSION_ALERT_ID = "SELF_EXCLUSION_ALERT_ID";
export const SELF_EXCLUSION = "self-exclusion";

export const SELF_EXCLUSION_ERROR_CODES = {
	externalLink: "E_SELFEXCLUSION_EXTERNALLINK",
};

export const TRANSLATION_KEYS = {
	confirm_title: "self-exclusion.confirm-title",
	confirm_message: "self-exclusion.confirm-message",
	confirm_message_indefinite: "self-exclusion.confirm-message.indefinite",
	indefinite: "self-exclusion.indefinitely",
	cancel_button: "general.cancel",
	confirm_button: "general.confirm",
};
